<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8">
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px] pt-[12px]"
          >
            <div class="w-full flex flex-col items-center">
              <MedicalKitIcon class="w-[50px] h-[50px] text-primary" />
              <span class="PC_Body1-SB !text-[#1F1D1F]"> เลือกทีมเจ้าหน้าที่ </span>
            </div>

            <SelectBox2
              :searchable="true"
              :allowEmpty="true"
              label="ทีมเจ้าหน้าที่"
              :inputId="'formTeamId'"
              :keyValue="'id'"
              :keyName="'name'"
              :options="allTeam"
              :value="form.team_id"
              :placeholder="'เลือกทีมเจ้าหน้าที่'"
              :warningMessage="errors.team_id"
              :hideValues="[form.hideTeam_id]"
              @update:modelValue="
                (res) => {
                  form.team_id = res;
                }
              "
            />
            <SelectBox2
              :searchable="true"
              :allowEmpty="true"
              label="ตำแหน่งหน้าที่"
              :inputId="'formTeamPosition'"
              :keyValue="'id'"
              :keyName="'name'"
              :options="positionOption"
              :value="form.team_position"
              :placeholder="'เลือกตำแหน่งหน้าที่'"
              :warningMessage="errors.team_position"
              @update:modelValue="
                (res) => {
                  form.team_position = res;
                }
              "
            />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--save'"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "../../components/Utilities/javascripts/useGlobals";
import { useTeamStore } from "@/pinia/team";
import { storeToRefs } from "pinia";

const positionOption = [{ id: 2, name: "สมาชิก" }];

const { $validateMsg } = useGlobals();
const teamStore = useTeamStore();
const { allTeam } = storeToRefs(teamStore);
const input = {
  user_id: "",
  team_id: "",
  team_position: "",
  hideTeam_id: "", // ใช้ซ่อน team ปัจจุบัน
};
const form = ref({ ...input });
const errors = ref({ ...input });
const Edit = ref(false);
const modalIsOpened = ref(false);

const openModal = (data, checkEdit) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  // console.log("data", data);
  form.value = {
    ...input,
  };
  errors.value = {
    ...input,
  };
  if (data) {
    form.value.user_id = data.id;
    // form.value.team_id = data.team_id || "";
  }
  // ตรวจสอบว่า เพิ่ม หรือ ย้ายพื้นที่
  if (checkEdit) {
    Edit.value = checkEdit;
    form.value.hideTeam_id = data.team_id;
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const emit = defineEmits(["success"]);

const save = async () => {
  if (Edit.value) {
    update();
  } else {
    add();
  }
};

const add = async () => {
  await teamStore
    .joinTeam(form.value)
    .then((response) => {
      if (response.status === 200) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

const update = async () => {
  await teamStore
    .transferTeam(form.value)
    .then((response) => {
      if (response.status === 200) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>

<style scoped></style>
